import FieldEditor from "editor/FieldEditor";
import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";
import FieldEditorWysiwyg from "editor/FieldEditorWysiwyg";


class ContentAdminEditorWysiwyg extends ContentAdminEditor {

    static get_name() {
        return 'Wysiwyg';
    }


    getInputType() {
        return '2';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        return [
            {
                name: 'slug',
                label: 'Slug',
                type: 'text'
            },
            {
                name: 'inline',
                label: 'Inline',
                type: 'checkbox'
            },
            {
                name: 'removePlugins',
                label: 'Disabled Plugins',
                type: 'text'
            },
            {
                name: 'extraPlugins',
                label: 'Extra Plugins',
                type: 'text'
            },
            {
                name: 'maxLength',
                label: 'Max Length',
                type: 'text'
            },
            {
                name: 'allowedTags',
                type: 'text',
                label: 'Allowed Elements',
                default: '',
                placeholder: FieldEditorWysiwyg.DEFAULT_TAGS
            }
        ];
    }

}

FieldEditor.register_editor('content/admin/wysiwyg', ContentAdminEditorWysiwyg);

export default ContentAdminEditorWysiwyg;
